(function () {
  'use strict';

  // Nav scroll state
  var nav = document.querySelector('.nav');
  if (nav) {
    var onScroll = function () { nav.classList.toggle('scrolled', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Mobile drawer
  var mobileToggle = document.querySelector('.mobile-nav-toggle');
  var mobileDrawer = document.querySelector('.mobile-drawer');
  var mobileClose = document.querySelector('.mobile-drawer__close');
  if (mobileToggle && mobileDrawer) {
    mobileToggle.addEventListener('click', function () { mobileDrawer.classList.add('open'); });
  }
  if (mobileClose && mobileDrawer) {
    mobileClose.addEventListener('click', function () { mobileDrawer.classList.remove('open'); });
  }

  // Cart drawer
  var drawer = document.querySelector('.cart-drawer');
  var overlay = document.querySelector('.cart-drawer__overlay');

  function openCart() {
    if (drawer) drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (drawer) drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); closeCart(); });
  });
  if (overlay) overlay.addEventListener('click', closeCart);

  function money(cents) {
    var format = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount(_no_decimals)?(_with_comma_separator)?\s*\}\}/g, value);
  }

  function renderCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var body = document.querySelector('.cart-drawer__body');
        var foot = document.querySelector('.cart-drawer__foot');
        var count = document.querySelector('[data-cart-count]');
        if (count) count.textContent = cart.item_count;
        if (!body) return;

        if (cart.item_count === 0) {
          body.innerHTML = '<div class="cart-drawer__empty"><p>Your basket is quietly waiting.</p><a href="/collections/all" class="cart-drawer__checkout" data-cart-close>Continue shopping</a></div>';
          if (foot) foot.style.display = 'none';
          return;
        }
        if (foot) foot.style.display = 'block';

        var html = cart.items.map(function (item) {
          var img = item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/, '_120x$1$2') : '';
          var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<div class="cart-item__variant">' + item.variant_title + '</div>' : '';
          return '<div class="cart-item" data-key="' + item.key + '">' +
            '<div class="cart-item__img"><img src="' + img + '" alt=""></div>' +
            '<div>' +
              '<div class="cart-item__title">' + item.product_title + '</div>' + variant +
              '<div class="cart-item__row">' +
                '<div class="cart-item__qty">' +
                  '<button type="button" data-qty-change="-1">-</button>' +
                  '<input type="number" value="' + item.quantity + '" min="0" data-qty-input>' +
                  '<button type="button" data-qty-change="1">+</button>' +
                '</div>' +
                '<span class="cart-item__price">' + money(item.final_line_price) + '</span>' +
              '</div>' +
              '<button type="button" class="cart-item__remove" data-remove>Remove</button>' +
            '</div>' +
          '</div>';
        }).join('');
        body.innerHTML = html;

        var subtotalEl = document.querySelector('[data-cart-subtotal]');
        if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

        body.querySelectorAll('.cart-item').forEach(function (row) {
          var key = row.getAttribute('data-key');
          row.querySelectorAll('[data-qty-change]').forEach(function (btn) {
            btn.addEventListener('click', function () {
              var input = row.querySelector('[data-qty-input]');
              var delta = parseInt(btn.getAttribute('data-qty-change'), 10);
              updateItem(key, Math.max(0, parseInt(input.value, 10) + delta));
            });
          });
          var input = row.querySelector('[data-qty-input]');
          if (input) input.addEventListener('change', function (e) { updateItem(key, parseInt(e.target.value, 10)); });
          var remove = row.querySelector('[data-remove]');
          if (remove) remove.addEventListener('click', function () { updateItem(key, 0); });
        });
      });
  }

  function updateItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(renderCart);
  }

  // Ajax product forms
  document.querySelectorAll('form[action="/cart/add"], form[action^="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () { renderCart(); openCart(); })
        .catch(function () { window.location.href = '/cart'; })
        .then(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
    });
  });

  if (drawer) renderCart();
})();
